export const MIN_DRAG_X = 2;
export const MIN_DRAG_Y = 2;